// DP217 — browser-side working-day maths, same rule as backend utils/schedule_dates.py:
// the start day is not counted; "3 working days from Mon 5 Oct" is Thu 8 Oct.
// Weekday index 0 = Monday (company_settings.work_week). Holidays are "YYYY-MM-DD".

export const DEFAULT_CALENDAR = { work_week: [0, 1, 2, 3, 4], holidays: [] };

function toKey(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function parseDay(value) {
  if (!value) return null;
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : new Date(value.getFullYear(), value.getMonth(), value.getDate());
  }
  const s = String(value).slice(0, 10);
  const [y, m, d] = s.split('-').map(Number);
  if (!y || !m || !d) return null;
  return new Date(y, m - 1, d);
}

export function isWorkDay(d, cal = DEFAULT_CALENDAR) {
  const week = Array.isArray(cal?.work_week) && cal.work_week.length ? cal.work_week : DEFAULT_CALENDAR.work_week;
  const idx = (d.getDay() + 6) % 7; // JS Sunday=0 → Monday=0
  if (!week.includes(idx)) return false;
  return !(cal?.holidays || []).includes(toKey(d));
}

export function addWorkingDays(startValue, n, cal = DEFAULT_CALENDAR) {
  const start = parseDay(startValue);
  if (!start) return null;
  const count = Math.max(0, Math.floor(Number(n) || 0));
  const d = new Date(start);
  let done = 0;
  let guard = 0;
  while (done < count && guard < 3660) {
    d.setDate(d.getDate() + 1);
    guard += 1;
    if (isWorkDay(d, cal)) done += 1;
  }
  return toKey(d);
}

export function formatDay(value) {
  const d = parseDay(value);
  if (!d) return '—';
  return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
}

export function workingDaysBetween(aValue, bValue, cal = DEFAULT_CALENDAR) {
  const a = parseDay(aValue);
  const b = parseDay(bValue);
  if (!a || !b) return 0;
  const sign = b > a ? 1 : -1;
  const d = new Date(a);
  let n = 0;
  let guard = 0;
  while ((sign > 0 ? d < b : d > b) && guard < 3660) {
    d.setDate(d.getDate() + sign);
    guard += 1;
    if (isWorkDay(d, cal)) n += 1;
  }
  return n * sign;
}

export function startOfWeek(value) {
  const d = parseDay(value) || new Date();
  const x = new Date(d.getFullYear(), d.getMonth(), d.getDate());
  x.setDate(x.getDate() - ((x.getDay() + 6) % 7));
  return x;
}

export function dayKey(d) {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}
